<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size:30px" class="mb-0">Trabajadores</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro=true">Registro</v-btn>
          <v-btn @click="registro=false">Admin</v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- Datos empleado -->
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="idempleado"
                :items="empleadosselect"
                :search-input.sync="searchempleado"
                flat
                hide-no-data
                hide-details
                label="Buscar colaborador..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Informacion empleado -->
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-12" dense>
              <span class="font-weight-bold primary--text">Datos personales</span>
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field v-model="nombres" ref="nombres" label="Nombres" dense class="pt-0" required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field v-model="apellidos" ref="apellidos" label="Apellidos" dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="lista_areas"
                        item-value="id"
                        item-text="nombre_area"
                        v-model="lareas"
                        dense
                        class="pt-0"
                        label="Areas"
                        ref="lareas"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="primary" class="mb-5" @click="save" :disabled="overlay2">Guardar</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="empleado_headers"
                :items="empleados"
                :search="searchempleados"
                sort-by="empresa"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Colaboradores</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">
                          <span class=".font-weight-thin">¿Desactivar item?</span>
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion==1">activar</span>
                          <span v-if="adAccion==2">desactivar</span>
                          el item asoaciado a
                          <strong>{{adNombre}}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                          >Cancelar</v-btn>
                          <v-btn
                            v-if="adAccion==1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                          >Activar</v-btn>
                          <v-btn
                            v-if="adAccion==2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                          >Desactivar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchempleados"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.condicion="{ item }">
                  <v-chip class="ma-2" x-small color="primary" v-if="item.condicion"> Contrato vigente </v-chip>
                  <v-chip class="ma-2" x-small v-else> Contrato no vigente </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemEmpleado(item)"
                  >mdi-square-edit-outline</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data() {
    return {
      //Ayuda
      show1: false,
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      errorMessages: "",
      form1HasErrors: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogcontrato: false,
      servicios: false,
      lista_areas: [],
      lareas: "",
      //Tablas
      empleado_headers: [
        { text: "Empresa", value: "empresa" },
        { text: "Area", value: "area" },
        { text: "Nombres", value: "nombres" },
        { text: "Apellidos", value: "apellidos" },
        { text: "DNI", value: "dni" },
        { text: "Puesto", value: "puesto" },
        { text: "Fecha inicio", value: "fecha_inicio" },
        { text: "Fecha fin", value: "fecha_fin" },
        { text: "Estado", value: "condicion", sortable: false, aling:"center" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      empleados: [],
      areaid: "",
      empleadosselect: [],
      searchempleado: "",
      searchempleados: "",
      /*Datos personales */
      idempleado: "",
      dni: "",
      nombres: "",
      apellidos: "",
      /* Contratos*/
      headercontratos: [
        { text: "Contrato", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],
      contratos: [],
      ayudacondicion:true,
      contratoid:"",
      /*Soporte*/
      valida: 0,
      validamensaje: [],
    };
  },
  created() {
    let me = this;
    me.selectEmpleado();
    this.cargarAreasUsuaria();
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },
  computed: {
    form1() {
      return {
        nombres: this.nombres,
        apellidos: this.apellidos,
        lareas: this.lareas
       };
    }
  },
  methods: {
    abrirDialogContrato() {
      this.dialogcontrato = true;
      this.limpiarContrato();
    },
    remove(item) {
      const index = this.clasificacion_locacion.indexOf(item);
      if (index >= 0) this.clasificacion_locacion.splice(index, 1);
    },
    /*Empleado*/
    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.idempleado;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },
    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.selectEmpleado();
    },
    Activar() {
      let me = this;
      axios
        .put("/api/Empleados/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.selectEmpleado();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    Desactivar() {
      let me = this;
      axios
        .put("/api/Empleados/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.selectEmpleado();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;

        const ref = this.$refs[f];

        if (ref && typeof ref.validate === "function") {
          ref.validate(true);
        } else {
          console.warn(`El ref '${f}' no existe o no tiene validate()`);
        }
      });
    },
    editItemEmpleado(item) {
      this.overlay = true;
      this.idempleado = item.idempleado;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    /* Tabla */
    selectEmpleado() {
      let me = this;
      var Array = [];
      me.empleadosselect = [];
      axios
        .get("api/Empleados/SelectEmpleo")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empleadosselect.push({ text: x.empleado, value: x.idempleado });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },

    editItem() {
      this.overlay = true;
      let me = this;
      var Array = [];
      axios
        .get("api/Empleados/Mostrar/" + me.idempleado)
        .then(function (response) {
          // console.log(response.data.idempleado);
          me.idempleado = response.data.idempleado;
          me.nombres = response.data.nombres;
          me.apellidos = response.data.apellidos;
          me.lareas = response.data.id_areausuaria;
          me.editedIndex = 1;
          me.nuevo = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    limpiar() {
      let me = this;
      me.dni = "";
      me.nombres = "";
      me.apellidos = "";
      me.editedIndex = -1;
      me.nuevo = true;
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    async cargarAreasUsuaria() {
      try {
        const response = await axios.get("/api/AreaUsuaria/Listar");
        this.lista_areas = response.data;
      } catch (error) {
        console.error("Error cargando areas:", error);
      }
    },
    save() {
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndex > -1) {
          let me = this;
          axios
            .put("/api/Empleados/Actualizar", {
              idempleado: me.idempleado,
              nombres: me.nombres,
              apellidos: me.apellidos,
              id_areausuaria: me.lareas,
            })
            .then(function (response) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        } else {
          let me = this;
          axios
            .post("/api/Empleados/Crear", {
              nombres: me.nombres,
              apellidos: me.apellidos,
              id_areausuaria: me.lareas,
            })
            .then(function (response) {
              me.idempresa = Number(response.data);
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        }
      }
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
</style>